module.exports = __webpack_public_path__ + "img/legal_auth.aaa5f10f.svg";